module.exports = {
  example: {
    title: 'Geolocation | Nissan | English',
    header: 'Geolocation for Nissan',
    attemptingGeoDataMessage: 'Attempting to fetch geolocation data...'
  },
  modal: {
    header: 'Update your location',
    paragraph: 'Please enter a valid US address below.',
    close: 'CLOSE',
    zip: 'ZIP',
    city: 'City',
    state: 'State',
    or: 'or',
    update: 'UPDATE',
    loading: 'Locating...',
    errors: {
        invalid: 'You\'ve either entered invalid fields or are missing fields.',
        unavailable: 'We can\'t access your location. Please enter a valid US address below.'
    }
  },
  nav: {
    loading: 'LOCATING',
    unavailable: 'Enter Location'
  }
};


// WEBPACK FOOTER //
// ./i18n/nissan/en.js